import { store } from './store'
import { Provider } from 'react-redux'
import React, { ReactNode } from 'react'

type ReduxProvider = {
  children: ReactNode
}

const ReduxProvider = ({ children }: ReduxProvider) => {
    return (
      <Provider store={store}>
        {children}
      </Provider>
    )
  }
  
  export default ReduxProvider